<template>
  <v-text-field
    dense
    filled
    rounded
    :color="isDarkMode ? 'grey lighten-5' : 'primary'"
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
  />
</template>

<script>
import { VTextField } from "vuetify/lib/components";
import { mapGetters } from "vuex";

export default {
  mixins: [VTextField],
  name: "AknTextField",
  computed: {
    ...mapGetters(["isDarkMode"]),
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__slot {
    padding: 0 16px !important;
  }
}
</style>
